import React, { useState, useEffect, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import PasswordModal from './PasswordModal';
import { verifyPassword } from '../utils/passwordUtils';
import { sendProtectedView, sendContentUnlocked } from '../utils/pageView';

interface ProtectedPageProps {
  children: ReactNode;
  password: string | string[];
  isOpen?: boolean;
  description?: string;
}

const ProtectedPage: React.FC<ProtectedPageProps> = ({
  children,
  password,
  isOpen = true,
  description
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(isOpen);
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      const fullPath = `${location.pathname}${location.search}${location.hash}`;
      sendProtectedView(location.pathname, fullPath);
    }
    // 마운트 시 1회만 발화
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePasswordSuccess = () => {
    const fullPath = `${location.pathname}${location.search}${location.hash}`;
    sendContentUnlocked(location.pathname, fullPath);
    setIsAuthenticated(true);
    setShowPasswordModal(false);
  };

  // 페이지 진입 시 비밀번호 모달 표시
  useEffect(() => {
    setShowPasswordModal(isOpen);
  }, [isOpen]);

  // 암호화된 비밀번호 검증
  const handlePasswordVerification = (inputPassword: string): boolean => {
    if (Array.isArray(password)) {
      return password.some(pwd => verifyPassword(inputPassword, pwd));
    }
    return verifyPassword(inputPassword, password);
  };

  if (!isAuthenticated) {
    return (
      <PasswordModal
        isOpen={showPasswordModal}
        onSuccess={handlePasswordSuccess}
        correctPassword={password}
        verifyPassword={handlePasswordVerification}
        description={description}
        variant="page"
      />
    );
  }

  return <>{children}</>;
};

export default ProtectedPage; 